import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// import { push } from 'connected-react-router'

// amplify
import { Auth, API } from 'aws-amplify'
import { listLocationsByOrganization } from './../../graphql/queries'
import { createAddress, createLocation } from './../../graphql/mutations'

import { AuthAccount, Location } from '../../../API'
import { Place } from 'aws-sdk/clients/location'
import { AnyRecord } from 'dns'

interface LocationState {
    organizationLocations: Location[]
}

const initialState: LocationState = {
    organizationLocations: []
}

export const getOrganizationLocations: any = createAsyncThunk(
    'location/getOrganizationLocations',
    async (organizationId: string, { dispatch, getState }) => {
        try {

            const { authAccount }: any = getState()

            const { data }: any = await API.graphql({
                query: listLocationsByOrganization,
                variables: {
                    organizationID: authAccount.selectedStaffProfile.organizationID
                }
            })
            const locations: Location[] = data.listLocationsByOrganization.items
            return locations
        } catch (err) {
            console.error(err)
        }
    }
)

export const createOrganizationLocation: any = createAsyncThunk(
    'location/createOrganizationSite',
    async (props: { geoObject: any, locationName: string }, { dispatch, getState }) => {
        try {

            console.log('passed geoObject: ', props.geoObject, props.locationName)

            const { authAccount }: any = getState()

            const createAddressResponse: any = await API.graphql({
                query: createAddress,
                variables: {
                    input: {
                        streetAddress: `${props.geoObject.addressNumber} ${props.geoObject.street}`,
                        city: props.geoObject.municipality,
                        state: props.geoObject.region,
                        zip: props.geoObject.postalCode.substring(0, 5),
                        zipPlusFour: props.geoObject.postalCode,
                        longitude: props.geoObject.geometry.point[0],
                        latitude: props.geoObject.geometry.point[1]
                    }
                }
            })

            const { data }: any = await API.graphql({
                query: createLocation,
                variables: {
                    input: {
                        type: 'physical',
                        name: props.locationName,
                        addressID: createAddressResponse.data.createAddress.id,
                        organizationID: authAccount.selectedStaffProfile.organizationID
                    }
                }
            })

            console.log('created location: ', data.createLocation)

            return data.createLocation
        } catch (err) {
            console.error(err)
        }
    }
)

export const locationSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        clearLocalLocationData: (state) => {
            state.organizationLocations = []
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getOrganizationLocations.fulfilled, (state, { payload }) => {
            state.organizationLocations = payload
        })
        builder.addCase(createOrganizationLocation.fulfilled, (state, { payload }) => {
            const currentOrganizationLocationList = state.organizationLocations.concat()
            currentOrganizationLocationList.push(payload)
            state.organizationLocations = currentOrganizationLocationList
        })
    }
})

export const { clearLocalLocationData } = locationSlice.actions
export default locationSlice.reducer